@let editingPageConfiguration = store.editingPageConfigurationSg();

<div class="atn-page-configuration-query-tab">
  <div class="atn-page-configuration-query-tab__content">
    <atn-ds-code
      class="atn-page-configuration-query-tab__query-editor"
      label="Query"
      [json]="editingPageConfiguration.query"
      (jsonChange)="queryChangeHandler($event)"
    />

    <!-- TODO: Uncomment this once run query is implemented -->
    <!-- <atn-ds-code
      class="atn-page-configuration-query-tab__preview"
      syntax="json"
      [readonly]="true"
    ></atn-ds-code> -->
  </div>
</div>
